var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73656 17.4345L8.45461 10.8336H4.95706L8.37578 2.09696H13.9723L10.8659 7.92136H14.3075L5.93594 17.4345H5.73656Z",
    fill: "#FED832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8104 2.19415L10.8564 7.73295L10.704 8.01854H11.0277H14.0928L5.8921 17.3376H5.88142L8.489 11.0047L8.59947 10.7366H8.30961H5.0994L8.44221 2.19415H13.8104ZM14.134 2H8.30961L4.81497 10.9307H8.30961L5.59156 17.5317H5.97985L14.5223 7.8244H11.0277L14.134 2Z",
    fill: "#FED832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62334 2.26488L8.62567 2.25886L8.62761 2.25245L8.64605 2.19421H8.44259L5.09977 10.7367H5.30828L8.62334 2.26488ZM8.59984 10.7367L8.48957 11.0048L5.88179 17.3376H5.89247L6.26717 16.9119L8.66896 11.0785L8.77943 10.8106L8.80991 10.7367H8.59984Z",
    fill: "#FED832"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5317,
    height: 15.5317,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.c6f723ecbbaf7f37de5ecbd6b930843f.svg";
export { ForwardRef as ReactComponent };